export default (to, from, next) => {
  var userRole = window.sessionStorage.getItem('userRole');
  if (to.name == 'Settings') {
    if (userRole == 'MANAGER' || userRole == 'OWNER') {
      return next();
    }
    return next('/');
  }
  return next();
};
